const colors = {
    white: "#FFFFFF",
    black: "#000000",
  
    gray100: "#f8f9fa",
    gray200: "#e9ecef",
    gray300: "#dee2e6",
    gray400: "#ced4da",
    gray500: "#adb5bd",
    gray600: "#6c757d",
    gray700: "#495057",
    gray800: "#343a40",
    gray900: "#212529",
  
    primary: "#0000FF", 
    primaryLight: "#5b9bff",
    primaryDark: "#002080",
  
    
    secondary: "#FF0000", 
    secondaryLight: "#ff5b5b",
    secondaryDark: "#a00000",
  
    success: "#28a745", 
    successLight: "#6ddf7a",
    successDark: "#1a732d",
  
    warning: "#ffc107",
    warningLight: "#ffe066",
    warningDark: "#b28704",
  
    danger: "#dc3545",
    dangerLight: "#f08090",
    dangerDark: "#9b2530",
  
    info: "#17a2b8", 
    infoLight: "#66d0e1",
    infoDark: "#116472",
  
    neutralLight: "#f4f4f4",
    neutralDark: "#d1d1d1",
  
   
    blue: "#007bff",
    lightBlue: "#5bc0de",
    cyan: "#17a2b8",
    teal: "#20c997",
    green: "#87D068",
    yellow: "#ffc107",
    orange: "#fd7e14",
    red: "#dc3545",
    pink: "#e83e8c",
    purple: "#6f42c1",
    specialGold: "#e5c016", 
    royalPurple: "#391EDE",
    gris: "#34495e", 
    dark: "#000000", 
    blueligth: "#62ede0", 
    blueDark: "#1890ff",
    lightGray: "#B1BBD2",
    strong_blue: "#0C2375",
    

  };
  
  export default colors;
  